document.addEventListener("DOMContentLoaded", function () {
    // Hide all sections except "1890s" on page load
    hideAllSectionsExcept("1890");
    setActiveButton("1890-button");
  
    // Attach click event listeners to all timeline-year-buttons
    const buttons = document.querySelectorAll(".timeline-year-button");
    buttons.forEach((button) => {
      button.addEventListener("click", handleButtonClick);
    });
  });
  
  function handleButtonClick(event) {
    const clickedButton = event.target;
    const year = clickedButton.id.replace("-button", ""); // Extract the year
  
    // Hide all sections except the selected section
    hideAllSectionsExcept(year);
  
    // Remove active class from all buttons
    removeActiveClassFromButtons();
  
    // Show the selected section and add active class to the clicked button
    showSection(year);
    setActiveButton(clickedButton.id);
  }
  
  function hideAllSectionsExcept(yearToKeep) {
    const sections = document.querySelectorAll(".timeline-section");
    sections.forEach((section) => {
      const sectionId = section.id;
      if (sectionId !== yearToKeep) {
        section.style.display = "none";
      } else {
        section.style.display = "block";
      }
    });
  }
  
  function showSection(year) {
    const section = document.getElementById(year);
    if (section) {
      section.style.display = "block";
    }
  }
  
  function removeActiveClassFromButtons() {
    const buttons = document.querySelectorAll(".timeline-year-button");
    buttons.forEach((button) => {
      button.classList.remove("active");
    });
  }
  
  function setActiveButton(buttonId) {
    const button = document.getElementById(buttonId);
    if (button) {
      button.classList.add("active");
    }
  }